/* eslint-disable */

import { useState, useContext, useEffect } from "react";
import { Context } from "../../App";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { db } from "../../config/firebase";
import {
  getDocs,
  collection,
  query,
  where,
  orderBy,
  limit,
  arrayUnion,
  doc,
  getDoc,
  setDoc,
  Timestamp,
  updateDoc,
  onSnapshot
} from "firebase/firestore";
import { AnimatePresence, motion } from "framer-motion";

import { CiStickyNote } from "react-icons/ci";
import { RxCaretSort } from "react-icons/rx";
import { RxCross2 } from "react-icons/rx";
import { FiSearch } from "react-icons/fi";
import { PiPaperPlaneRightFill } from "react-icons/pi";
import { v4 as uuidv4 } from 'uuid';
import dayjs from "dayjs";

import { PiNotePencil } from "react-icons/pi";
import { CiFolderOn } from "react-icons/ci";


import ReactGA from "react-ga4";
import IndividualFolder from "./components/IndividualFolders";
import IndividualFile from "./components/IndividualFile";
import LeftBarAnimation from "../../components/animations/SideBarAnimation";

const UserNotes = ({ folderData, getChats }) => {
  const location = useLocation();

  const { showUsersContext,
    showMediaContext, fileIdContext, filesListContext, quillDocsContext, folderDetailsContext } = useContext(Context);
  const [showUsers, setShowUsers] = showUsersContext;
  const [showMedia, setShowMedia] = showMediaContext;
  const [quillDocs, setQuillDocs] = quillDocsContext;

  const [fileId, setFileId] = fileIdContext;


  const [isEditing, setIsEditing] = useState(false);

  const [folder, setFolder] = useState("");
  const [fileName, setFileName] = useState("");

  const [currFolder, setCurrFolder] = folderDetailsContext;
  const [currFileName, setCurrFileName] = useState("");

  const [filesList, setFilesList] = filesListContext;
  const [foldersList, setFoldersList] = folderData;


  const [currUserTab, setCurrUserTab] = useState({
    name: fileId === "" ? "Folders" : "Notes"
  })
  const [userTab, setUserTab] = useState([
    {
      name: "Folders"
    },
    {
      name: "Notes"
    }])

  const [select, setSelect] = useState(1);// (all, buy, sell) select
  const [percentFilter, setpercentFilter] = useState(false);
  const [timeFilter, setTimeFilter] = useState(false);
  const [search, setSearch] = useState("");

  // console.log(foldersList);

  const leftIn = {
    hidden: {
      x: "-190px",
      opacity: 0,
    },
    visible: {
      x: "0",
      opacity: 1,
      transition: {
        duration: 0.15,
        type: "spring",
        damping: 30,
        stiffness: 500,
        // type: "linear",
      },
    },
    exit: {
      x: "-190px",
      opacity: 0,
    },
  };

  const handleFoldersPinned = async (id) => {

    let isPinned = false;
    setFoldersList((prev) => (prev.map((item) => {
      if (item.id === id) {
        isPinned = !item.isPinned;
        return { ...item, isPinned: !item.isPinned }
      }
      return item
    })))

    try {
      const docRef = doc(db, 'notesFolders', id);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        await updateDoc(docRef, {
          isPinned,
        });
        console.log("Document successfully Edited: ", id, isPinned);
      } else {
        // console.log("DNE: ",);
      }

    } catch (error) {
      // console.error("Error adding document: ", error);
    }
  };

  const handleFilesPinned = async (id) => {

    let isPinned = false;

    try {
      const folderDocRef = doc(db, 'notesFolders', currFolder.id);
      const folderDocSnap = await getDoc(folderDocRef);

      if (folderDocSnap.exists()) {
        let allFiles = folderDocSnap.data().files;

        allFiles = allFiles.map((item) => {
          if (item.id === id) {
            isPinned = !item.isPinned;
            return { ...item, isPinned: !item.isPinned }
          }
          return item
        })

        setFilesList(allFiles) //Update file in UI

        await updateDoc(folderDocRef, {
          files: allFiles
        });

        const docRef = doc(db, 'notes', id);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          await updateDoc(docRef, {
            isPinned,
          });
          console.log("Document successfully Edited: ", id, isPinned);
        } else {
          // console.log("DNE: ",);
        }

      } else {
        console.log("DNE: ", currFolder.id);
      }


    } catch (error) {
      // console.error("Error adding document: ", error);
    }
  };

  const handleCreateFolder = async () => {

    const enteredData = {
      createdAt: dayjs().format(),
      name: folder,
      createdById: localStorage.getItem("uid"),
      displayName: localStorage.getItem("displayName"),
      isPinned: false,
      files: [],
    }


    try {
      const docRef = doc(db, 'notesFolders', uuidv4());

      await setDoc(docRef, enteredData);
      // console.log("Document Uploaded", enteredData);
      setFoldersList((prev) => ([...prev, enteredData]));
      setIsEditing(false);
      setFolder("");
    } catch (error) {
      // console.error("Error adding document: ", error);
    }
  }

  const handleCreateFile = async () => {

    const enteredData = {
      createdAt: dayjs().format(),
      name: fileName,
      folderName: currFolder.name,
      folderId: currFolder.id,
      createdById: localStorage.getItem("uid"),
      displayName: localStorage.getItem("displayName"),
      isPinned: false,
      notes: ""
    }
    const newFileId = uuidv4();

    try {
      const folderDocRef = doc(db, 'notesFolders', currFolder.id);
      const docSnap = await getDoc(folderDocRef);

      if (docSnap.exists()) {
        let allFiles = docSnap.data().files;

        await updateDoc(folderDocRef, {
          files: [...allFiles,
          {
            name: fileName,
            id: newFileId,
            createdAt: dayjs().format(),
            isPinned: false,
          }],
        });

        const fileDocRef = doc(db, 'notes', newFileId);
        await setDoc(fileDocRef, enteredData);

        setFilesList((prev) => ([...prev, {
          name: fileName,
          id: newFileId
        }]));
        setIsEditing(false);
        setFileName("");

      } else {
        console.log("DNE: ", currFolder.id);
      }

    } catch (error) {
      // console.error("Error adding document: ", error);
    }
  }

  const handleKeyDownCreateFile = (e) => {
    if (e.key === 'Enter' && fileName !== "") {
      handleCreateFile();
    }
    if (e.key === 'Escape') {
      // console.log("SUBMIT");
      setIsEditing(false);
    }
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && folder !== "") {
      handleCreateFolder();
    }
    if (e.key === 'Escape') {
      // console.log("SUBMIT");
      setIsEditing(false);
    }
  }

  useEffect(() => {
    setFolder("");
    setIsEditing(false);
  }, [currUserTab])


  useEffect(() => {

    const getFoldersList = async (id) => {
      // setIsLoading(true)
      try {
        const collectionRef = collection(db, 'notesFolders')
        // let q = query(collectionRef, where('submittedBy', '==', auth?.currentUser.uid));
        let q = query(collectionRef, where("createdById", "==", localStorage.getItem("uid")), limit(15));

        const data = await getDocs(q);
        const reqData = data.docs.map((item) => ({
          ...item.data(),
          id: item.id
        }))
        setFoldersList(reqData);

        // console.log(reqData);
      } catch (error) {
        // console.log(error);

      }
      // setIsLoading(false)
    }

    getFoldersList();
  }, [filesList])

  const fetchQuillText = async (id) => {
    const fileDocRef = doc(db, 'notes', id);


    try {
      const docSnap = await getDoc(fileDocRef);

      if (docSnap.exists()) {
        // console.log(docSnap.data());
        const fromLS = localStorage.getItem(id);
        if (fromLS) {
          const
            { createdAt, notes } = JSON.parse(fromLS)
          // console.log();
          if (docSnap.data().createdAt < createdAt) { //Content of LS is NEWER
            setQuillDocs(notes)
          }
          else setQuillDocs(docSnap.data().notes)
        }
        else setQuillDocs(docSnap.data().notes)

      } else {
        // console.log("DNE: ", currFolder.id);
      }

    } catch (error) {
      // console.error("Error adding document: ", error);
    }
  }

  return (<LeftBarAnimation showDiv={showUsers} variants={leftIn} overlayDirection={"left"} >
    <div className={`flex w-full h-full flex-col`}>

      <div className="w-full justify-end">
        <div className="flex justify-evenly w-full">
          {userTab.map((item, i) => (
            <button
              style={{ "zIndex": currUserTab.name === item.name ? 0 : 10 }}
              key={item.name + "tabs----"}
              className={`px-1 py-1 text-xs w-1/2 md:text-sm uppercase items-center dark:!bg-navyDL dark:shadow-none 
                                ${currUserTab.name === item.name ? "text-gray-800 hover:text-gray-700 bg-white dark:text-white " : "text-gray-600 hover:text-gray-700 bg-gray-50"}`}
              onClick={() => { setCurrUserTab(userTab[i]) }}>
              <div className="inline">{item.name}</div>
            </button>

          ))}

        </div>
      </div>

      <div style={{
        "position": "relative",
        "top": "-1px"
      }} className="flex flex-col h-[calc(100%-26px)] w-full border-t border-headPrimary bg-white dark:bg-navyDL">

        <div className="filterbar p-1">
          <div className="mb-2 gap-5 bg-white uppercase dark:!bg-navy-800">

            <div className="mt-2 w-full flex justify-between">
              <div className="ml-1 w-[49%] flex h-[19px] items-center rounded-sm bg-lightPrimary text-navy-700 dark:bg-navy-900 dark:text-white">
                <p className="px-1">
                  <FiSearch className="h-3 w-3 text-gray-400 dark:text-white" />
                </p>
                <input
                  type="text"
                  placeholder="Search..."
                  className="block h-full w-full bg-lightPrimary text-xs font-medium text-navy-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark:placeholder:!text-white"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />

                <p
                  onClick={() => (setSearch(""))}
                  className="pl-1 pb-0.5 pr-1 text-xl">
                  <RxCross2 className="cursor-pointer h-3 w-3 text-gray-400 hover:text-gray-800 dark:text-white" />
                </p>

              </div>

              <div className={`flex items-center ${percentFilter ? "text-gray-800 dark:text-white" : "text-gray-400 hover:text-gray-700"
                }  `}
                onClick={() => {
                  setpercentFilter((prev) => (!prev));
                }}>
                <p className="relative cursor-pointer text-xs">%&nbsp;</p>
                <RxCaretSort />
              </div>

              <div className={`flex items-center ${timeFilter ? "text-gray-800 dark:text-white" : "text-gray-400 hover:text-gray-700"
                }  `}
                onClick={() => {
                  setTimeFilter((prev) => (!prev));
                }}>
                <p className="relative cursor-pointer text-xs">Time&nbsp;</p>
                <RxCaretSort />
              </div>
            </div>

          </div>
        </div>
        <hr />

        <div className=" h-[calc(100%-44px)] overflow-y-auto">
          {currUserTab.name === "Folders" ?
            <>
              {/* ------------------------------| LIST OF FOLDERS |----------------------------------------------- */}
              <div className="w-full py-2 flex justify-center items-center">
                <button onClick={() => { setIsEditing(true) }}
                  className="bg-lightPrimary  text-headPrimary rounded-lg w-fit px-3 py-1 hover:font-bold hover:bg-headPrimary hover:text-white  text-lg flex items-center ">
                  <CiFolderOn className="w-4 h-4 mr-1" />

                  <div className="">Create Folder</div>
                </button>
              </div>

              {isEditing &&
                <div className="relative w-full flex items-center h-fit pl-px mt-2">
                  <input id="chat1"
                    autoFocus={true}
                    value={folder}
                    onKeyDown={handleKeyDown}
                    onChange={(e) => { setFolder(e.target.value) }}
                    className="py-1 px-2.5 pr-6 w-full text-base text-gray-900 bg-white border border-gray-300 focus:ring-headPrimary focus:border-headPrimary dark:bg-gray-800 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-headPrimary dark:focus:border-headPrimary" placeholder="New Folder Name"></input>

                  <PiPaperPlaneRightFill
                    onClick={() => { if (folder !== "") handleCreateFolder() }}
                    className="absolute top-0 bottom-0 my-auto right-1.5 cursor-pointer text-headPrimary hover:text-our-600  h-4 w-4" />

                </div>
              }

              <table className="w-full">
                <tbody className="cursor-pointer text-gray-500">
                  {foldersList.sort(function (a, b) {  //default sort /by selected then /by name
                    if (a.isPinned && !b.isPinned) {
                      return -1;
                    }
                    else if (!a.isPinned && b.isPinned) {
                      return 1;
                    }
                    else {
                      if (a.name <= b.name) { return -1; }
                      if (a.name > b.name) { return 1; }
                    }
                  }).filter((item) => (!item.isIndividual &&
                    (search === "" || item.name.toLowerCase().includes(search.toLowerCase()) || item.groupId.toLowerCase().includes(search.toLowerCase()))))
                    .map((item, i) => (
                      < IndividualFolder key={item.id} item={item} handleFoldersPinned={handleFoldersPinned} setCurrUserTab={setCurrUserTab}
                        setCurrFolderData={[currFolder, setCurrFolder]} setFilesList={setFilesList} />
                    ))}


                </tbody>
              </table>
            </>
            :
            //* ------------------------------| LIST OF FILES |----------------------------------------------- */
            <><div className="w-full py-2 flex justify-center items-center">
              <button
                disabled={!currFolder}
                onClick={() => { setIsEditing(true) }}
                className={`flex items-center w-fit px-3 py-1 text-lg rounded-lg  
                ${!currFolder ? "bg-gray-200 text-gray-600" : "bg-lightPrimary  text-headPrimary hover:font-bold hover:bg-headPrimary hover:text-white"}`}
              // "bg-lightPrimary  text-headPrimary rounded-lg w-fit px-3 py-1 hover:font-bold hover:bg-headPrimary hover:text-white  text-lg flex items-center "
              >
                <PiNotePencil className="w-4 h-4 mr-1" />

                <div className="">Create Note</div>
              </button>
            </div>

              {isEditing &&
                <div className="relative w-full flex items-center h-fit pl-px mt-2">
                  <input id="chat"
                    value={fileName}
                    onKeyDown={handleKeyDownCreateFile}
                    onChange={(e) => { setFileName(e.target.value) }}
                    className="py-1 px-2.5 pr-6 w-full text-base text-gray-900 bg-white border border-gray-300 focus:ring-headPrimary focus:border-headPrimary dark:bg-gray-800 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-headPrimary dark:focus:border-headPrimary" placeholder="New Note Name"></input>

                  <PiPaperPlaneRightFill
                    onClick={() => { if (fileName !== "") handleCreateFile() }}
                    className="absolute top-0 bottom-0 my-auto right-1.5 cursor-pointer text-headPrimary hover:text-our-600  h-4 w-4" />

                </div>
              }

              <table className="w-full">
                <tbody className="cursor-pointer text-gray-500">
                  {filesList.sort(function (a, b) {  //default sort /by selected then /by name
                    if (a.isPinned && !b.isPinned) {
                      return -1;
                    }
                    else if (!a.isPinned && b.isPinned) {
                      return 1;
                    }
                    else if (timeFilter) {
                      if (a.createdAt <= b.createdAt) { return 1; }
                      if (a.createdAt > b.createdAt) { return -1; }
                    }
                    else {
                      if (a.name <= b.name) { return -1; }
                      if (a.name > b.name) { return 1; }
                    }
                  }).filter((item) => (!item.isIndividual &&
                    (search === "" || item.name.toLowerCase().includes(search.toLowerCase()) || item.groupId.toLowerCase().includes(search.toLowerCase()))))
                    .map((item, i) => (
                      < IndividualFile key={item.id} item={item} handleFilesPinned={handleFilesPinned} setFileId={setFileId}
                        setCurrUserTab={setCurrUserTab} fetchQuillText={fetchQuillText} />
                    ))}
                </tbody>
              </table>
            </>
          }

        </div>

      </div>
    </div>
  </LeftBarAnimation>
  );
};

export default UserNotes;
